import Vue from 'vue';
import App from './App.vue';
import './styles.css';

new Vue({
  render: h => h(App),
}).$mount('#app');